// When the costs & settlements screens show: only for an office with the
// COSTS_AND_SETTLEMENTS feature, switched on per office by Rentio staff in
// the Backoffice (Lewis, 2026-10-20). There is no global feature flag: the
// feature is managed per office, not per environment (Lewis, 2026-10-28).
// Only the screens are hidden; the API stays reachable (decision D3).

export interface ICostsVisibility {
  isEnabled: boolean;
  // The office is not known yet: the screens stay hidden for now, but
  // nothing may act on "hidden" (e.g. strip a shared link to a cost from the
  // URL) until the office has loaded.
  isLoading: boolean;
}

export const getCostsVisibility = (params: {
  hasOfficeFeature: boolean;
  isFetchingOffice: boolean;
}): ICostsVisibility => {
  const { hasOfficeFeature, isFetchingOffice } = params;

  return {
    isEnabled: hasOfficeFeature,
    isLoading: !hasOfficeFeature && isFetchingOffice,
  };
};
